Tooltip = require 'components/common/tooltip'

Button = React.createClass
  render: ->
    <Tooltip>
      <button {...this.props}>{@props.label}</button>
    </Tooltip>

module.exports = Button
